Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getElementAttrs = void 0;

exports.getElementAttrs = function (props) {
  var extraAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.assign({
    'aria-hidden': props.ariaHidden,
    'aria-label': props.ariaLabel,
    'tab-index': props.tabIndex,
    colSpan: props.colspan,
    dateTime: props.datetime,
    htmlFor: props.for,
    hidden: props.hidden,
    id: props.id,
    title: props.title
  }, extraAttrs);
};